export const noCacheHeaders = {
  'Cache-Control': 'no-cache',
  'Pragma': 'no-cache',
  'Expires': '0',
}

/** @param {object} GenerateRequestHashHeaderDTO
 * @param {string} GenerateRequestHashHeaderDTO.hash
 * @returns {{ 'x-fingerprint': string}} */
export const generateRequestHashHeader = (hash) => {
  return {
    'x-fingerprint': hash,
  }
}
